/**
 * Test IDs for QA automation.
 */
export const testIds = {
  orgSettingsEditorGeneral: "org-settings-editor-general",
  orgSettingsEditorDispatching: "org-settings-editor-dispatching",
  orgSettingsEditorInvoicing: "org-settings-editor-invoicing",
  orgSettingsEditorRatecon: "org-settings-editor-ratecon",
  orgSettingsEditorCustomField: "org-settings-editor-custom-field",
  orgSettingsEditorDemoUtils: "org-settings-editor-demo-utils",
  orgSettingsEditorSimpleWorkflow: "org-settings-editor-simple-workflow",
  orgSettingsEditorSingleClickCompletion: "org-settings-editor-single-click-completion",
  orgSettingsEditorFutureTrips: "org-settings-editor-future-trips",
  orgSettingsEditorAdHocAddress: "org-settings-editor-ad-hoc-address",
  orgSettingsEditorAlternatePinCode: "org-settings-editor-alternate-pin-code",
  orgSettingsEditorChangeTripOrder: "org-settings-editor-change-trip-order",
  orgSettingsEditorTrackCommodity: "org-settings-editor-track-commodity",
  orgSettingsEditorConsolidateInProgressShipments: "org-settings-editor-consolidate-in-progress-shipments",
  orgSettingsEditorTankCapacityWarnings: "org-settings-editor-tank-capacity-warnings",
  orgSettingsEditorSelectLogo: "org-settings-editor-select-logo",
  orgSettingsEditorRemoveInvoiceLogo: "org-settings-editor-remove-invoice-logo",
  orgSettingsEditorSelectEmailLogo: "org-settings-editor-select-email-logo",
  orgSettingsEditorRemoveEmailLogo: "org-settings-editor-remove-email-logo",
  orgSettingsEditorPrefix: "org-settings-editor-prefix",
  orgSettingsEditorSingleNumberInvoicing: "org-settings-editor-single-number-invoicing",
  orgSettingsEditorNextInvoiceNumber: "org-settings-editor-next-invoice-number",
  orgSettingsEditorSaveNextInvoiceNumber: "org-settings-editor-save-next-invoice-number",
  orgSettingsEditorConfigureChargeTypes: "org-settings-editor-configure-charge-types",
  orgSettingsEditorConfigureAccessorialTypes: "org-settings-editor-configure-accessorial-types",
  orgSettingsEditorToggleTaxRate: "org-settings-editor-toggle-tax-rate",
  orgSettingsEditorConfigureRemitAddress: "org-settings-editor-configure-remit-address",
  orgSettingsEditorConsolidateShipments: "org-settings-editor-consolidate-shipments",
  orgSettingsEditorApplyAllPrimaryRateTables: "org-settings-editor-apply-all-primary-rate-tables",
  orgSettingsEditorReceiverDocumentationSubjectTemplateToggle: "org-settings-editor-receiver-documentation-subject-template-toggle",
  orgSettingsEditorReceiverDocumentationSubjectTemplateField: "org-settings-editor-receiver-documentation-subject-template-field",
  orgSettingsEditorReceiverDocumentationBodyTemplate: "org-settings-editor-receiver-documentation-body-template",
  orgSettingsEditorRateconTermsAndConditions: "org-settings-editor-ratecon-terms-and-conditions",
  orgSettingsEditorEmailSubjectTemplate: "org-settings-editor-email-subject-template",
  orgSettingsEditorEmailBodyTemplate: "org-settings-editor-email-body-template",
  orgSettingsEditorSaveSettings: "org-settings-editor-save-settings",
  orgSettingsEditorCancel: "org-settings-editor-cancel",
  orgSettingsEditorSave: "org-settings-editor-save",
  orgSettingsEditorTrackNetAndGrossVolumes: "org-settings-editor-track-net-and-gross-volumes",
  orgSettingsEditorEnableEta: "org-settings-editor-enable-eta",
  orgSettingsEditorDefaultTrailerType: "org-settings-editor-default-trailer-type",
  orgSettingsEditorShipperDwellTime: "org-settings-shipper-dwell-time-input",
  orgSettingsEditorReceiverDwellTime: "org-settings-receiver-dwell-time-input",

  orgSettingsEditorInvoicePrimaryColor: "org-settings-editor-invoice-primary-color",
} as const;
